import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Grid,
  TextField,
  Typography
} from '@mui/material'
import { ExpandMoreOutlined } from '@mui/icons-material'
import Drawer from 'components/drawer/detail'
import Loading from 'components/loading/loading'
import { useGetUsersAccountDetailQuery } from 'store/control'
import type { DetailStateProps } from 'modules/types'
import DetailStyle from './style'

const Detail = ({ open, id, onClose }: DetailStateProps & { id: string }) => {
  if (!open) return <Drawer open={open} onClose={onClose} />

  const { data, isFetching, isLoading } = useGetUsersAccountDetailQuery(id)

  const userId = (data && data.userId) || '-'
  const email = (data && data.email) || '-'
  const details = data && data.usersDetails && data.usersDetails[0]
  const fullName =
    (details &&
      details.firstName &&
      details.lastName &&
      details.firstName + ' ' + details.lastName) ||
    (details && details.firstName) ||
    '-'
  const mobilePhone = (details && details.mobilePhone) || '-'
  const birthday = (details && details.birthday) || '-'

  const gridDataLabel = ['User ID', 'email', 'Full Name', 'Mobile Phone', 'Birthday']
  const gridDataValue = [userId, email, fullName, mobilePhone, birthday]

  const createdBy = data && data.createdBy
  const createdAt = data && data.createdAt
  const modifiedBy = data && data.modifiedBy
  const modifiedAt = data && data.modifiedAt

  const gridBasicLabel = ['Created By', 'Created At', 'Modified By', 'Modified At']
  const gridBasicValue = [createdBy, createdAt, modifiedBy, modifiedAt]

  return (
    <Drawer open={open} title='Role Assignment Detail' onClose={onClose}>
      <Container {...DetailStyle.Container}>
        {(isLoading || isFetching) && !data && <Loading />}
        {data && (
          <Grid container spacing={2}>
            {gridDataValue.map((item, index) => (
              <Grid key={index} item xs={12}>
                <TextField
                  variant='outlined'
                  label={gridDataLabel[index]}
                  value={item}
                  inputProps={{ readOnly: true }}
                  multiline
                  fullWidth
                />
              </Grid>
            ))}
          </Grid>
        )}
        {data && (
          <Accordion elevation={0} disableGutters>
            <AccordionSummary expandIcon={<ExpandMoreOutlined />} aria-controls='basic-information'>
              <Typography>Basic Information</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                {gridBasicValue.map((item, index) => (
                  <Grid key={index} item xs={12}>
                    <TextField
                      variant='outlined'
                      label={gridBasicLabel[index]}
                      value={item}
                      inputProps={{ readOnly: true }}
                      fullWidth
                    />
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}
      </Container>
    </Drawer>
  )
}

export default Detail
